<template>
	<div class="cut-line"></div>
</template>

<script>
	export default {
		name: 'cutLine',
		
		data() {
			return {
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.cut-line  {
		height: .2rem;
		background: #F2F2F2;
	}
	.c-form .cut-line {
		margin: .2rem -.32rem;
	}
</style>
